'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

/**
 * Callback to deserialize a string value in local storage to a desired
 * type.
 *
 * @callback fromStorage
 * @param {string} value The stringified value that will be transformed.
 * @returns {any} The desired, deserialized value.
 */

/**
 * Callback to serialize a value to a string for storage.
 *
 * @callback toStorage
 * @param {string} value The value to be stringified.
 * @returns {string} The value as a string.
 */

/**
 * Hook for retreiving and storing a single item in local/session storage.
 *
 * @param {object} config
 * @param {string} config.key A unique identified for the value in storage.
 * @param {any} [config.initialValue=null] The initial value to store if no value is already
 *   in storage.
 * @param {toStorage} [config.toStorage=x => x] Callback to serialize the value.
 *   Defaults to the identity function which will rely on the storage object
 *   to cast the value to a string.
 * @param {fromStorage} [config.fromStorage=x => x] Callback to deserialize the value
 *   from it's string representation in storage. Defaults to the identity
 *   function.
 * @param {localStorage|sessionStorage} [config.storage=sessionStorage] The
 *  storage mechanism to use. Defaults to `sessionStorage`.
 * @example
 * const [value, setValue] = useStoredState({
 *   key: 'myVariable',
 *   initialValue: true,
 *   toStorage: x => x ? 'true' : 'false',
 *   fromStorage: x => x === 'true',
 * })
 * @returns {[any, function]} Returns an array containing the current
 *   (deserialized) value and the callback to update the value.
 */

var useStoredState = _ref => {
  var {
    key,
    initialValue = null,
    toStorage = x => x,
    fromStorage = x => x,
    storage = sessionStorage
  } = _ref;

  if (!key) {
    throw new Error('A key must be provided for state value.');
  }

  var loadedValue = storage.getItem(key);
  var [value, setValue] = React__namespace.useState(loadedValue === null ? initialValue : fromStorage(loadedValue));
  React__namespace.useEffect(() => {
    if (value === null || value === undefined) {
      storage.removeItem(key);
    } else {
      storage.setItem(key, toStorage(value));
    }
  }, [key, value, toStorage, storage]);
  return [value, newValue => setValue(newValue === undefined ? null : newValue)];
};

exports.default = useStoredState;
exports.useStoredState = useStoredState;
